'use client'

import { useEffect, useState } from "react";
import { LOCAL_STORAGE_TOKEN_KEY } from "@/app/_components/query-provider";
import { signOut, useSession } from "next-auth/react";

export default function LocalTokenCleaner() {

  const { status } = useSession()
  const [signOutRequested, setSignOutRequested] = useState(false)

  useEffect(() => {
    if (!signOutRequested && status === 'authenticated') {
      setSignOutRequested(true)
      fetch('/api/token-acknowledgement', { method: 'DELETE' })
          .then(() => console.log('Removed Signature Header'))
          .then(() => signOut())
          .then(() => console.log('Signed out'))
    }
  }, [status]);

  useEffect(() => {
    if (localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)) {
      console.log('Removing local Storage')
      localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY)
    }
  }, [])

  return (
    <></>
  )
}